import { __decorate, __metadata } from "tslib";
import { RelativePosition } from './RelativePosition';
import { SerializableObject, SerializableMember } from '../decorators';
import { AngularVelocity } from '../values';
import { AngularVelocityUnit } from '../../utils';
/**
 * Relative angular velocity to another reference object
 * @category Position
 */
let RelativeAngularVelocity = class RelativeAngularVelocity extends RelativePosition {
  constructor(referenceObject, velocity) {
    super(referenceObject, velocity, AngularVelocityUnit.RADIAN_PER_MINUTE);
  }
  get velocity() {
    return this.referenceValue;
  }
  set velocity(value) {
    this.referenceValue = value;
  }
};
__decorate([SerializableMember(), __metadata("design:type", AngularVelocity)], RelativeAngularVelocity.prototype, "referenceValue", void 0);
RelativeAngularVelocity = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, AngularVelocity])], RelativeAngularVelocity);
export { RelativeAngularVelocity };